import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const eocUserNotificationsRoute: InvariantJiraRoute = {
	name: 'eoc-user-notifications',
	path: '/jira/settings/products/ops/role-assignment/notifications/:targetAccountId',
	exact: true,
};
